var map = {
	"./arrowLeft.svg": 7584,
	"./arrowRight.svg": 8452,
	"./back.svg": 1650,
	"./home.svg": 194,
	"./instagram.svg": 7927,
	"./link.svg": 9749,
	"./logo100.svg": 7118,
	"./logo100White.svg": 3869,
	"./play.svg": 8831,
	"./up.svg": 2887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8278;